import React from 'react';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
const cx = classNames.bind();

function Loader() {
    const { isLoading } = useSelector((state) => state.loading);

    return (
        <Card style={{ position: 'relative' }}>
            <Card.Body className={cx({ whirl: isLoading })}></Card.Body>
        </Card>
    );
}

export default Loader;
